module.exports = __webpack_public_path__ + "static/img/hb_25-min.80a1ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_25-min.png
// module id = 3ozZ
// module chunks = 1